module.exports = __webpack_public_path__ + "static/media/logo-토닥@2x.24504ea8.png";